export default "__VITE_ASSET__DgfgeLUI__";